import React, { useEffect, useRef, useState } from 'react'
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { connect } from 'react-redux';

import { updateMemberCredit, viewProfileAction } from '../../actions/viewProfileAction';

import CompanyInfo from '../../components/ViewProfile/CompanyInfo';
import CompanyPlanInfo from '../../components/ViewProfile/CompanyPlanInfo';
import ServiceInfo from '../../components/ViewProfile/ServiceInfo';
import CertificatesInfo from '../../components/ViewProfile/CertificatesInfo';
import AboutCompany from '../../components/ViewProfile/AboutCompany';
import ContactDetail from '../../components/ViewProfile/ContactDetail';
import LocationDetail from '../../components/ViewProfile/LocationDetail';

import companyDetails from "../../images/company_details.svg";
import companyLocation from "../../images/company_locations.svg";
import CompanyInfoIcon from "../../images/company-info-icon.svg"
import { isEmpty, parseInt, size } from 'lodash';
import CompanyImageVideo from '../../components/ViewProfile/CompanyImageVideo';
import SubHeader from '../../components/SubHeader';
import { hideLoading, showLoading } from '../../actions/loaderAction';
import { ToastContainer } from "react-toastify";
import { buildPath, capitalizeWords, downloadExcel, getPrefix } from '../../utils/common';
import { useAuth } from '../../AuthProvider';
import MediumPopup from "../../components/MediumPopup";
import SupplierInquiry from "../../components/inquiry/SupplierInquiry";
import LogisticInquiry from '../../components/inquiry/LogisticInquiry';
// import { Button } from 'react-bootstrap';
import ButtonAdminpanel from '../../components/ButtonAdminpanel';
import CreditExceed from '../../components/common/CreditExceed';
import ToolipsCustom from '../../components/ToolipsCustom';
import ReadMore from '../../components/ReadMore';
import NoDataFound from '../../components/common/NoDataFound';
import Emitter from "../../utils/Emitter";

import roles from "../../constant/roles.config";
import { privateRoutePaths } from '@/routes/private.route.config';



function ViewProfile(props) {
  const { id } = useParams();

  const [searchParams, setSearchParams] = useSearchParams();
  const [userStatus, setUserStatus] = useState(null);
  const { isEndUser, isSuperAdmin, isDemoUser, memberCompanyID, isPreKYCUser, user, isViewer, isOpUser, isInqUser, isAdmin } = useAuth();

  const [cr, setCR] = useState(null);
  const [memberHeadAddress, setMemberHeadAddress] = useState(null);
  const [memberBranchAddress, setMemberBranchAddress] = useState(null);
  const [memberCertificates, setMemberCertificates] = useState(null);
  const [memberContacts, setMemberContacts] = useState(null);
  const [memberServices, setMemberServices] = useState(null);
  const [memberdetail, setMemberDetail] = useState(null);
  const [memberHsCode, setMemberHsCode] = useState(null);
  const [memberTargetCountries, setMemberTargetCountries] = useState(null);
  const [cInfo, setcInfo] = useState(null);
  const [cPlanInfo, setCPlanInfo] = useState({});
  const [mediaDetails, setMediaDetails] = useState(null);
  const [showMediaSection, setShowMediaSection] = useState(false);
  const [showOtherSection, setShowOtherSection] = useState(false);
  const initialRef = useRef(true);
  const tradeModeRef = useRef(null);
  const [isChecked, setIsChecked] = useState(false);
  const [chkList, setChkList] = useState([]);
  const [isDownloadable, setIsDownloadable] = useState(false);

  const [mediummodalShow, setMediumModalShow] = useState(false);
  const [memberPort, setMemberPort] = useState(null);
  const [creditModalShow, setCreditModalShow] = useState(false);

  const [hideAboutCompany, setHideAboutCompany] = useState(true);
  const [hideTradingCountries, setHideTradingCountries] = useState(true);
  const [hidePorts, setHidePorts] = useState(true);
  const [hideMemberCon, setHideMemberCon] = useState(true);
  const [hideServices, setHideServices] = useState(true);
  const [hidePlanInfo, setHidePlanInfo] = useState(true);
  const [hideHistoryLog, setHideHistoryLog] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isAddressExpanded, setIsAddressExpanded] = useState(false);
  const [isEndAdrExpanded, setIsEndAdrExpanded] = useState(false);
  const [isHsExpanded, setHsExpanded] = useState(false);
  const [isTargetExpanded, setTargetExpanded] = useState(false);
  const [isPortExpanded, setPortExpanded] = useState(false);
  const [isReadMore, setIsReadMore] = useState(false);
  const [isAddressReadMore, setIsAddressReadMore] = useState(false);
  const [isEndAdrReadMore, setIsEndAdrReadMore] = useState(false);
  const [isHsReadMore, setHsReadMore] = useState(false);
  const [isTargetReadMore, setTargetReadMore] = useState(false);
  const [isPortReadMore, setPortReadMore] = useState(false);
  const buttonWrapRef = useRef(null);
  const [height, setHeight] = useState(0);

  const [inqAllowed, setInqAllowed] = useState(false);

  const checkIfInquiryAllowed = (compnyInfo) => {

    const userTradeMode = user.trade_mode_type;
    const companyTradeMode = compnyInfo.trade_mode_type;
    const uRole = user.role_slug.slug;

    if (uRole === "END_USER") {
      if (parseInt(user.member_id) !== parseInt(id)) { // check it should not be his own profile
        if (compnyInfo.data_source === "WEB") { // Inquiry should be raisd to registered data only

          if (userTradeMode === "BUYER" && companyTradeMode !== "BUYER") { // Buyer --> Supplier, Logistic
            setInqAllowed(true);
          }

          if (userTradeMode === "SUPPLIER" && companyTradeMode === "LOG_PTR") { // Supplier --> Logistic
            setInqAllowed(true);
          }

          if (userTradeMode === "LOG_PTR" && companyTradeMode === "LOG_PTR") { // Logistic --> Logistic
            setInqAllowed(true);
          }
        }
      }
    }

    if (uRole === "DEMO") {
      if (parseInt(user.member_id) !== parseInt(id)) {
        if (compnyInfo.data_source === "WEB" || compnyInfo.data_source === "DEMO") {
          setInqAllowed(true);
        }
      }
    }
  }

  const fetchCompanyProfile = async (id) => {
    await props.showLoading();
    await props.viewCompany(id).then(async (response) => {
      if (response.status === false) {
        tradeModeRef.current = "BUYER_SUPPLIER";
        if (response.message === "MAX_LIMIT_REACHED") {
          handleCreditModal();
          await props.hideLoading();

        }
      }

      if (response.status) {

        if (!isEmpty(response.data)) {
          const savedUser = localStorage.getItem("user");
          let userInfo = savedUser ? JSON.parse(savedUser) : null;
          if (userInfo && userInfo.role_slug && (userInfo.role_slug.slug !== "VIEWER" && userInfo.role_slug.slug !== "SUP_ADM" && userInfo.role_slug.slug !== "DEMO" && userInfo.role_slug.slug !== "OPERATION_USER" && userInfo.role_slug.slug !== "PRE_KYC" && userInfo.role_slug.slug !== "INQ_MANAGER")) {
            props.updateMemberCredit(userInfo.member_id, id);
          }
          // setIsDownloadable(response.data[0].isDownloadable);


          const { branch_office_address, head_office_address, hs_codes, member_certificates, verified_member_certificates, member_contacts, member_services, memberdetail, social_medias, videos, images, trade_countries,
            ports } = response.data[0];

          const companyRepresentative = {
            salutation: response.data[0].salutation,
            first_name: response.data[0].first_name,
            last_name: response.data[0].last_name,
            email: response.data[0].email,
            designation: response.data[0].designation,
            country: (!isEmpty(response.data[0].country)) ? response.data[0].country.name : '',
            city: (!isEmpty(response.data[0].member_city)) ? response.data[0].member_city.name : '',
            phone: response.data[0].phone,
            mobile: response.data[0].mobile,
            company_representative_image: response.data[0].company_representative_image,
            id: response.data[0].id,
          }

          const companyInformation = {
            company_name: response.data[0].company_name,
            company_logo: response.data[0].company_logo,
            company_size: response.data[0].company_size,
            shipment_mode: response.data[0].shipment_mode,
            trade_mode_type: response.data[0].trade_mode_type,
            website: response.data[0].website,
            industry: response.data[0].member_industry.industy_name,
            country: (!isEmpty(response.data[0].country)) ? response.data[0].country.name : '',
            city: (!isEmpty(response.data[0].member_city)) ? response.data[0].member_city.name : '',
            status: response.data[0].status,
            est_dt: (response.data[0].establish_date) ? response.data[0].establish_date : '',
            // verfied_company: (response.data[0].notVerified > 0 || (response.data[0].notVerified === 0 && isEmpty(member_certificates))) ? false : true,
            social_medias: social_medias,
            orexID: response.data[0].member_unique_number,
            data_source: response.data[0].data_source


          }


          if (!isEmpty(response.data[0].memberdetail)) {
            if ((response.data[0].memberdetail.plan_id != null || response.data[0].memberdetail.plan_id !== "") && response.data[0].memberdetail.plan_id > 0) {
              setHidePlanInfo(false);
              //setHideHistoryLog(false);
            }
          }

          // if (!isEmpty(response.data[0].memberdetail)) {
          //   console.log('response.data[0].memberdetail.plan_id ---> ', response.data[0].memberdetail.plan_id);
          //   if (!isEmpty(response.data[0].memberdetail.plan_id) && response.data[0].memberdetail.plan_id > 0) {
          //     console.log('response.data[0].memberdetail.plan_id ---> ', response.data[0].memberdetail.plan_id);
          //     setHidePlanInfo(false);
          //   }
          // }

          const companyPlanInfo = {
            id: response?.data?.[0]?.id ?? '',
            badge: response?.data?.[0]?.badge ?? '',
            plan_to_date: response?.data?.[0]?.plan_to_date ?? '',
            plan_from_date: response?.data?.[0]?.plan_from_date ?? '',
            plan_name: response?.data?.[0]?.memberdetail?.subscription_plan?.name ?? '',
            orex_certificate: response?.data?.[0]?.orex_certificate ?? '',
          };


          const companyVideos = {
            videos: videos,
            images: images,
            company_logo: response.data[0].company_logo
          }

          if (isEmpty(videos) && isEmpty(images)) {
            setShowMediaSection(false);
          } else {
            setShowMediaSection(true);
          }

          setcInfo(companyInformation);
          setMediaDetails(companyVideos);
          setCPlanInfo(companyPlanInfo);

          if (!isEmpty(head_office_address)) {
            setMemberHeadAddress(head_office_address[0]);
          } else {
            let tmpHeadOffice = {
              address1: null,
              address2: null,
              city: null,
              country: (!isEmpty(response.data[0].head_office_country)) ? response.data[0].head_office_country : '',
              country_id: (!isEmpty(response.data[0].head_office_country)) ? response.data[0].head_office_country.id : '',
              office_type: 'Head',
              pincode: null,
              member_id: id
            };
            setMemberHeadAddress(tmpHeadOffice);
          }

          if (!isEmpty(branch_office_address)) {
            setMemberBranchAddress(branch_office_address);
          }
          //  else {
          //   let tmpBranchOffice = [{
          //     address1: null,
          //     address2: null,
          //     city: null,
          //     country: (!isEmpty(response.data[0].branch_office_country)) ? response.data[0].branch_office_country : '',
          //     country_id: (!isEmpty(response.data[0].branch_office_country)) ? response.data[0].branch_office_country.id : '',
          //     office_type: 'Branch',
          //     pincode: null,
          //     member_id: id
          //   }];
          //   setMemberBranchAddress(tmpBranchOffice);
          // }

          // setMemberBranchAddress(branch_office_address);
          if (member_certificates) {
            setMemberCertificates(member_certificates);
          } else if (verified_member_certificates) {
            setMemberCertificates(verified_member_certificates);
          }
          // setMemberCertificates(member_certificates);
          setMemberContacts(member_contacts);
          setMemberServices(member_services);
          setMemberDetail(memberdetail);
          setMemberHsCode(hs_codes);
          setMemberTargetCountries(trade_countries);
          setCR(companyRepresentative);
          setMemberPort(ports);
          // console.log("memberdetail  >>> ", memberdetail);
          // console.log("hs_codes  >>> ", hs_codes);
          // console.log("trade_countries  >>> ", trade_countries);
          if (((!isEmpty(memberdetail) && isEmpty(memberdetail.about_company)) || isEmpty(memberdetail)) && isEmpty(hs_codes) && isEmpty(trade_countries) && isEmpty(ports)) {
            setShowOtherSection(false);
          } else {
            setShowOtherSection(true);
          }
          if (!isEmpty(member_services)) {
            setHideServices(false);
          }
          if (!isEmpty(ports)) {
            setHidePorts(false);
          }
          if (!isEmpty(trade_countries)) {
            setHideTradingCountries(false);
          }
          if (!isEmpty(memberdetail)) {
            if (!isEmpty(memberdetail.about_company)) {
              setHideAboutCompany(false);
            }
          }
          if (!isEmpty(member_contacts)) {
            setHideMemberCon(false);
          }

          if (searchParams.get("lead") === null && searchParams.get("paid") === null && searchParams.get("pending") === null) {

            if (companyInformation.trade_mode_type !== "LOG_PTR") {
              tradeModeRef.current = "BUYER_SUPPLIER";
              Emitter.emit("TRADE_MODE_TYPE", "BUYER_SUPPLIER");
              if (userInfo && userInfo.role_slug && (userInfo.role_slug.slug == "END_USER") && userInfo.member_id == id) {
                tradeModeRef.current = "USER_PROFILE";
                Emitter.emit("TRADE_MODE_TYPE", "USER_PROFILE");
              }
              if (userInfo && userInfo.role_slug && (userInfo.role_slug.slug == "PRE_KYC") && userInfo.member_id == id) {
                tradeModeRef.current = "USER_PROFILE";
                Emitter.emit("TRADE_MODE_TYPE", "USER_PROFILE");
              }
              if (userInfo && userInfo.role_slug && (userInfo.role_slug.slug == "PRE_KYC") && userInfo.member_id != id) {
                tradeModeRef.current = "BUYER_SUPPLIER";
                Emitter.emit("TRADE_MODE_TYPE", "BUYER_SUPPLIER");
              }

            } else {
              tradeModeRef.current = "LOG_PTR";
              Emitter.emit("TRADE_MODE_TYPE", "LOG_PTR");
              if (userInfo && userInfo.role_slug && (userInfo.role_slug.slug == "END_USER") && userInfo.member_id == id) {
                tradeModeRef.current = "USER_PROFILE";
                Emitter.emit("TRADE_MODE_TYPE", "USER_PROFILE");
              } else if (userInfo && userInfo.role_slug && (userInfo.role_slug.slug == "PRE_KYC") && userInfo.member_id == id) {
                tradeModeRef.current = "USER_PROFILE";
                Emitter.emit("TRADE_MODE_TYPE", "USER_PROFILE");
              } else if (userInfo && userInfo.role_slug && (userInfo.role_slug.slug == "PRE_KYC") && userInfo.member_id != id) {
                tradeModeRef.current = "LOG_PTR";
                Emitter.emit("TRADE_MODE_TYPE", "LOG_PTR");
              }

            }
          } else {
            let l = searchParams.get("lead") || searchParams.get("paid") || searchParams.get("pending");
            let l1 = atob(l);
            if (l1 === "WEB") {
              tradeModeRef.current = "REG_LEAD";
              Emitter.emit("TRADE_MODE_TYPE", "REG_LEAD");
            }
            if (l1 === "Paid") {
              tradeModeRef.current = "PAID_LEAD";
              Emitter.emit("TRADE_MODE_TYPE", "PAID_LEAD");
            }
            if (l1 === "ProfileReq") {
              tradeModeRef.current = "PROFILE";
              Emitter.emit("TRADE_MODE_TYPE", "PROFILE");
            }

          }

          checkIfInquiryAllowed(response.data[0]);
        }


      }
    }).catch((err) => {
      console.log("Error ============ ", err);
      // showErrorMessage("Something went wrong");
    });
    setTimeout(async () => {
      await props.hideLoading();
    }, 2000);



  }

  const handleCreditModal = () => {
    setCreditModalShow(true);
  }

  useEffect(() => {
    setUserStatus(isEndUser);
  }, [isEndUser]);

  useEffect(() => {
    if (initialRef.current === true) {
      initialRef.current = false;
      fetchCompanyProfile(id);
    }
  }, [id]);



  const handlePopupShow = () => {

    /*if (cInfo && cInfo.trade_mode_type === 'LOG_PTR') {
      setMediumModalShow(true);
    } else if (cInfo && cInfo.trade_mode_type === 'SUPPLIER') {
      setMediumModalShow(true);
    } */

    setMediumModalShow(true);
  }

  const handleChange = (e) => {
    let cId = e.target.value;
    let cntInfo = {};
    if (e.target.checked) {
      if (e.target.name === "company_representative") {
        cntInfo = {
          company_name: cInfo.company_name,
          full_name: (!isEmpty(cr.salutation) ? cr.salutation + " " : "") + (!isEmpty(cr.first_name) ? cr.first_name + " " : "") + (!isEmpty(cr.last_name) ? cr.last_name : ""),
          designation: cr.designation,
          country: cr.country,
          phone: cr.phone,
          mobile: cr.mobile,
          email: cr.email,
          type: 'rep',
          id: cr.id
        }
      }

      if (e.target.name === "contact_person") {

        const cntInfo1 = memberContacts.find(obj => {
          return parseInt(obj.id) === parseInt(cId)
        });

        cntInfo = {
          company_name: cInfo.company_name,
          full_name: (!isEmpty(cntInfo1.salutation) ? cntInfo1.salutation + " " : "") + (!isEmpty(cntInfo1.first_name) ? cntInfo1.first_name + " " : "") + (!isEmpty(cntInfo1.last_name) ? cntInfo1.last_name : ""),
          designation: cntInfo1.designation,
          country: '',
          phone: cntInfo1.phone,
          mobile: '',
          email: cntInfo1.email,
          type: 'cp',
          id: cntInfo1.id
        }
      }

      let ckList = [...chkList];
      ckList.push(cntInfo);
      setChkList(ckList);
    } else {

      if (e.target.name === "company_representative") {
        let rData = [...chkList];

        const remData = rData.filter(function (obj) {
          return obj.type !== "rep";
        });
        setChkList(remData);
      }

      if (e.target.name === "contact_person") {
        let cData = [...chkList];
        const rData = cData.filter(function (obj) {
          return (obj.type === "rep" || (obj.type === "cp" && parseInt(obj.id) !== parseInt(cId)));
        });

        setChkList(rData);

      }
    }

    setIsChecked(!isChecked);
  }

  const handleDownloadChange = (e) => {

    let now = new Date();
    let year = now.getFullYear();
    let month = String(now.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    let day = String(now.getDate()).padStart(2, '0');
    let hours = String(now.getHours()).padStart(2, '0');
    let minutes = String(now.getMinutes()).padStart(2, '0');
    let seconds = String(now.getSeconds()).padStart(2, '0');

    let formattedDate = `${year}_${month}_${day}_${hours}_${minutes}_${seconds}`;
    let filename = 'contact_' + cInfo.orexID + '_' + formattedDate;

    let headers = [
      { label: 'Full Name', field: 'full_name' },
      { label: 'Email', field: 'email' },
      { label: 'Company Name', field: 'company_name' },
      { label: 'Phone', field: 'phone' },
      { label: 'Mobile', field: 'mobile' },
      { label: 'Country', field: 'country' },
      { label: 'Designation', field: 'designation' },
    ];

    if (e.target.name === "download") {
      const data = chkList;

      if (!isEmpty(data)) {
        downloadExcel(headers, data, filename);
      }
    } else if (e.target.name === "downloadAll") {
      let data = [];
      data = [{
        company_name: cInfo.company_name,
        full_name: (!isEmpty(cr.salutation) ? cr.salutation + " " : "") + (!isEmpty(cr.first_name) ? cr.first_name + " " : "") + (!isEmpty(cr.last_name) ? cr.last_name : ""),
        designation: cr.designation,
        country: cr.country,
        phone: cr.phone,
        mobile: cr.mobile,
        email: cr.email
      }];

      if (!isEmpty(memberContacts)) {
        memberContacts.forEach(mCon => {
          const memberCont = {
            company_name: cInfo.company_name,
            full_name: (!isEmpty(mCon.salutation) ? mCon.salutation + " " : "") + (!isEmpty(mCon.first_name) ? mCon.first_name + " " : "") + (!isEmpty(mCon.last_name) ? mCon.last_name : ""),
            designation: mCon.designation,
            country: '',
            phone: mCon.phone,
            mobile: '',
            email: mCon.email,
          };
          data.push(memberCont);
        });
      }

      if (!isEmpty(data)) {
        downloadExcel(headers, data, filename);
      }
    }
  }

  // const getPrefix = () => {
  //   if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
  //   if (user && isDemoUser) return roles.DEMO.prefix;
  //   if (user && isEndUser) return roles.END_USER.prefix;
  //   if (user && isViewer) return roles.VIEWER.prefix;
  //   return roles.SUPER_ADMIN.prefix;
  // };

  useEffect(() => {
    if (buttonWrapRef.current) {
      const elementHeight = buttonWrapRef.current.offsetHeight;
      setHeight(elementHeight);
    }
  }, [cInfo]);


  return (

    <div className='company-main'>

      {(isSuperAdmin || isViewer || isOpUser || isInqUser || isAdmin) && tradeModeRef.current === "BUYER_SUPPLIER" && <SubHeader layer1="Supplier Directory" layer2="Profile" layer3="View" pageName="Company View Profile" subTitle=""
        clickable={{
          layer1: `/${getPrefix(user)}${privateRoutePaths.MANAGE_MEMBERS.path}`,
          layer2: "",
          layer3: ""
        }}
      />}

      {(isSuperAdmin || isViewer || isOpUser || isInqUser || isAdmin) && tradeModeRef.current === "LOG_PTR" && <SubHeader layer1="Logistics Directory" layer2="Profile" layer3="View" pageName="Company View Profile" subTitle=""
        clickable={{
          layer1: `/${getPrefix(user)}${privateRoutePaths.MANAGE_LOGISTIC_MEMBERS.path}`,
          layer2: "",
          layer3: ""
        }}
      />}

      {(isSuperAdmin || isViewer || isOpUser || isInqUser || isAdmin) && tradeModeRef.current === "REG_LEAD" && <SubHeader layer1="Lead Management" layer2="Profile" layer3="View" pageName="Company View Profile" subTitle=""
        clickable={{
          layer1: `/${getPrefix(user)}${privateRoutePaths.MANAGE_LEADS.path}`,
          layer2: "",
          layer3: ""
        }}
      />}

      {(isSuperAdmin || isViewer || isOpUser || isInqUser || isAdmin) && tradeModeRef.current === "PROFILE" && <SubHeader layer1="Profile Requests" layer2="Profile" layer3="View" pageName="Company View Profile" subTitle=""
        clickable={{
          layer1: `/${getPrefix(user)}${privateRoutePaths.MANAGE_PENDING_MEMBERS.path}`,
          layer2: "",
          layer3: ""
        }}
      />}

      {(isSuperAdmin || isOpUser || isInqUser || isAdmin) && tradeModeRef.current === "PAID_LEAD" && <SubHeader layer1="Paid Members" layer2="Profile" layer3="View" pageName="Company View Profile" subTitle=""
        clickable={{
          layer1: `/${getPrefix(user)}${privateRoutePaths.MANAGE_PAID_MEMBERS.path}`,
          layer2: "",
          layer3: ""
        }}
      />
      }

      {
        isEndUser && (parseInt(memberCompanyID) === parseInt(id)) && <SubHeader layer1="Profile" layer2="View" layer3="" pageName="Company View Profile" subTitle=""
          clickable={{
            layer1: "",
            layer2: "",
            layer3: ""
          }}
        />
      }

      {
        isEndUser && (parseInt(memberCompanyID) !== parseInt(id)) && (tradeModeRef.current === "BUYER_SUPPLIER") && <SubHeader layer1="Supplier Directory" layer2="Profile" layer3="View" pageName="Company View Profile" subTitle=""
          clickable={{
            layer1: user && (user.trade_mode_type != "SUPPLIER" && user.trade_mode_type != "BUYER") ? `/${getPrefix(user)}${privateRoutePaths.MANAGE_MEMBERS.path}` : ``,
            layer2: "",
            layer3: ""
          }}
        />
      }

      {
        isEndUser && (parseInt(memberCompanyID) !== parseInt(id)) && tradeModeRef.current === "LOG_PTR" && <SubHeader layer1="Logistics Directory" layer2="Profile" layer3="View" pageName="Company View Profile" subTitle=""
          clickable={{
            layer1: user && (user.trade_mode_type != "SUPPLIER" && user.trade_mode_type != "BUYER") ? `/${getPrefix(user)}${privateRoutePaths.MANAGE_LOGISTIC_MEMBERS.path}` : ``,
            layer2: "",
            layer3: ""
          }}
        />
      }

      {
        isPreKYCUser && (parseInt(memberCompanyID) === parseInt(id)) && <SubHeader layer1="Profile" layer2="View" layer3="" pageName="Company View Profile" subTitle=""
          clickable={{
            layer1: "",
            layer2: "",
            layer3: ""
          }}
        />
      }

      {
        isPreKYCUser && (parseInt(memberCompanyID) !== parseInt(id)) && tradeModeRef.current === "BUYER_SUPPLIER" && <SubHeader layer1="Supplier Directory" layer2="Profile" layer3="View" pageName="Company View Profile" subTitle=""
          clickable={{
            layer1: "",
            layer2: "",
            layer3: ""
          }}
        />
      }

      {
        isPreKYCUser && (parseInt(memberCompanyID) !== parseInt(id)) && tradeModeRef.current === "LOG_PTR" && <SubHeader layer1="Logistics Directory" layer2="Profile" layer3="View" pageName="Company View Profile" subTitle=""
          clickable={{
            layer1: "",
            layer2: "",
            layer3: ""
          }}
        />
      }

      {
        isDemoUser && (parseInt(memberCompanyID) === parseInt(id)) && <SubHeader layer1="Profile" layer2="View" layer3="" pageName="Company View Profile" subTitle=""
          clickable={{
            layer1: "",
            layer2: "",
            layer3: ""
          }}
        />
      }

      {
        isDemoUser && (parseInt(memberCompanyID) !== parseInt(id)) && tradeModeRef.current === "BUYER_SUPPLIER" && <SubHeader layer1="Buyers/Suppliers Management" layer2="Profile" layer3="View" pageName="Company View Profile" subTitle=""
          clickable={{
            layer1: `/${getPrefix(user)}${privateRoutePaths.SHIPMENT_COMPANY_LIST.path}`,
            layer2: "",
            layer3: ""
          }}
        />
      }
      {
        isDemoUser && (parseInt(memberCompanyID) !== parseInt(id)) && tradeModeRef.current === "LOG_PTR" && <SubHeader layer1="Logistics Directory" layer2="Profile" layer3="View" pageName="Company View Profile" subTitle=""
          clickable={{
            layer1: `/${getPrefix(user)}${privateRoutePaths.MANAGE_LOGISTIC_MEMBERS.path}`,
            layer2: "",
            layer3: ""
          }}
        />
      }

      <div className='company-info-details new-design'>
        <div className='view-profile'>
          <div className='left-side'>
            <div className='card'>
              <CompanyInfo data={cInfo} memberdetail={memberdetail} />
            </div>
            {!hideAboutCompany &&
              <div className='card'>
                {showOtherSection && <div className=''>
                  {/* <h3 className='company-details-text'>
                  <img src={companyInoicon} alt="" className='company-info-icon mx-1' />
                  Company Other Details
                </h3> */}
                  <AboutCompany data={memberdetail} hs_codes={memberHsCode} target_countries={memberTargetCountries} cInfo={cInfo} ports={memberPort} images={""} />
                </div>
                }
              </div>
            }
            {!hideServices &&
              <div className='card'>
                <ServiceInfo data={memberServices} cInfo={cInfo} />
              </div>
            }
            <div className='row'>
              <div className='col-12'>
                <div className='card '>
                  <ContactDetail title="Company Representative" data={cr} onChange={handleChange} isDownloadable={isDownloadable} isStaffInfo={false} />
                  {/* <div className='other-contact'>
                    {!isReadMore && memberContacts && memberContacts.slice(0, 1).map((val, k) => {
                      return (<ContactDetail data={val} key={`contact_${k}`} onChange={handleChange} isDownloadable={isDownloadable} />)
                    })}
                    {isReadMore && memberContacts && memberContacts.map((val, k) => {
                      return (<ContactDetail data={val} key={`contact_${k}`} onChange={handleChange} isDownloadable={isDownloadable} />)
                    })}
                    {
                      (memberContacts && size(memberContacts) > 1) ? ( 
                        <ReadMore isReadMore={isReadMore} setIsReadMore={setIsReadMore} isExpanded={isExpanded} setIsExpanded={setIsExpanded}/>
                      ):""
                    }
                  </div> */}
                </div>
              </div>
              <div className="col-12">
                {!hideMemberCon &&
                  <div className='card '>
                    <h3>Staff Person</h3>
                    <div className='other-contact'>
                      {!isReadMore && memberContacts && memberContacts.slice(0, 1).map((val, k) => {
                        return (<ContactDetail data={val} key={`contact_${k}`} onChange={handleChange} isDownloadable={isDownloadable} isStaffInfo={true} />)
                      })}
                      {isReadMore && memberContacts && memberContacts.map((val, k) => {
                        return (<ContactDetail data={val} key={`contact_${k}`} onChange={handleChange} isDownloadable={isDownloadable} isStaffInfo={true} />)
                      })}
                      {
                        (memberContacts && size(memberContacts) > 1) ? (
                          <ReadMore isReadMore={isReadMore} setIsReadMore={setIsReadMore} isExpanded={isExpanded} setIsExpanded={setIsExpanded} />
                        ) : ""
                      }
                    </div>
                  </div>
                }
              </div>
              <div className='col-12'>
                <div className='card'>
                  <LocationDetail title="Head Office" data={memberHeadAddress} />

                  {
                    !isAddressReadMore && (isSuperAdmin || (memberCompanyID === id)) && memberBranchAddress && memberBranchAddress.slice(0, 1).map((val, k) => {
                      return (<LocationDetail title={`Branch Office ` + (k + 1)} data={val} key={k} />)
                    })
                  }
                  {
                    isAddressReadMore && (isSuperAdmin || (memberCompanyID === id)) && memberBranchAddress && memberBranchAddress.map((val, k) => {
                      return (<LocationDetail title={`Branch Office ` + (k + 1)} data={val} key={k} />)
                    })
                  }
                  {
                    (isSuperAdmin || (memberCompanyID === id)) && (memberBranchAddress && size(memberBranchAddress) > 1) ? (
                      <ReadMore isReadMore={isAddressReadMore} setIsReadMore={setIsAddressReadMore} isExpanded={isAddressExpanded} setIsExpanded={setIsAddressExpanded} />
                    ) : ""
                  }

                  {!isEndAdrReadMore && (isPreKYCUser || isEndUser) && (memberCompanyID !== id) && cInfo && cInfo.trade_mode_type !== "LOG_PTR" &&
                    memberBranchAddress && memberBranchAddress.slice(0, 1).map((val, k) => {
                      return (<LocationDetail title={`Branch Office ` + (k + 1)} data={val} key={k} />)
                    })
                  }

                  {isEndAdrReadMore && (isPreKYCUser || isEndUser) && (memberCompanyID !== id) && cInfo && cInfo.trade_mode_type !== "LOG_PTR" &&
                    memberBranchAddress && memberBranchAddress.map((val, k) => {
                      return (<LocationDetail title={`Branch Office ` + (k + 1)} data={val} key={k} />)
                    })
                  }

                  {
                    (isPreKYCUser || isEndUser) && (memberCompanyID !== id) && cInfo && cInfo.trade_mode_type !== "LOG_PTR" && memberBranchAddress && size(memberBranchAddress) > 1 ? (
                      <ReadMore isReadMore={isEndAdrReadMore} setIsReadMore={setIsEndAdrReadMore} isExpanded={isEndAdrExpanded} setIsExpanded={setIsEndAdrExpanded} />
                    ) : ""
                  }
                </div>
              </div>
            </div>
          </div>

          <div className='right-side'>
            <div className={height && height > 0 ? "button-wrape" : ''} ref={buttonWrapRef}>
              {(isSuperAdmin || isViewer) && !hideHistoryLog && tradeModeRef.current !== "PAID_LEAD" && (
                <Link
                  to={`/${getPrefix(user)}${buildPath(privateRoutePaths.PROFILE_HISTORY, { id: id })}`}
                  className='btn btn-primary-outline'
                >
                  <span>History Log</span>
                </Link>
              )}

              {(isSuperAdmin || isViewer) && !hideHistoryLog && tradeModeRef.current === "PAID_LEAD" && (
                <Link
                  to={`/${getPrefix(user)}${buildPath(privateRoutePaths.PROFILE_HISTORY, { id: id + "?history=" + btoa("LOG") })}`}
                  className='btn btn-primary-outline'
                >
                  <span>History Log</span>
                </Link>
              )}

              {inqAllowed && <ButtonAdminpanel className='btn btn-primary' type='button' onClick={() => handlePopupShow()}>
                Post Your Inquiry
              </ButtonAdminpanel>}

              { /** Post Your Inquiry button for Demo User */}
              {/* {(user && isDemoUser && cInfo && (cInfo.data_source === 'WEB' || cInfo.data_source === 'DEMO') && user.member_id != id) &&
                <ButtonAdminpanel className='btn btn-primary' type='button' onClick={() => handlePopupShow()}>
                  Post Your Inquiry
                </ButtonAdminpanel>
              } */}

              { /** Post Your Inquiry button for End User */}


              {/* {(isEndUser && cInfo && (cInfo.data_source === 'WEB') && user.member_id != id && (user.trade_mode_type === 'BUYER' || (user.trade_mode_type === 'SUPPLIER' && cInfo.trade_mode_type === 'LOG_PTR'))) &&
                <ButtonAdminpanel className='btn btn-primary' type='button' onClick={() => handlePopupShow()}>
                  Post Your Inquiry
                </ButtonAdminpanel>
              }


              {(isEndUser && cInfo && (cInfo.data_source === 'WEB') && user.member_id != id && (trade_mode_type === 'LOG_PTR' && cInfo.trade_mode_type === 'LOG_PTR')) &&
                <ButtonAdminpanel className='btn btn-primary' type='button' onClick={() => handlePopupShow()}>
                  Post Your Inquiry
                </ButtonAdminpanel>
              } */}
            </div>

            {!hidePlanInfo &&
              <div className='card'>
                <CompanyPlanInfo data={cPlanInfo} />
              </div>
            }
            {/* ******certification Info **** */}
            <div className='certification-wrape'>
              <CertificatesInfo data={memberCertificates} />
            </div>

            { /** Hs code */}
            <div className='card'>
              <h3>Hs Code</h3>
              <div className='Hsn_badge'>
                {!isHsReadMore && memberHsCode &&
                  memberHsCode.slice(0, 8).map(function (hs_code, indx) {
                    return (
                      <span className="badge" key={`hscode-main${indx}`}>
                        <ToolipsCustom
                          key={`hscode-tooltip-main-${indx}`}
                          title={hs_code.dictionary_hs_codes.code}
                          subtitle={hs_code.dictionary_hs_codes.description}
                          className={"badge"}
                        >
                        </ToolipsCustom>
                      </span>
                    );
                  })}

                {isHsReadMore && memberHsCode &&
                  memberHsCode.map(function (hs_code, indx) {
                    return (
                      <span className="badge" key={`hscode-main${indx}`}>
                        <ToolipsCustom
                          key={`hscode-tooltip-main-${indx}`}
                          title={hs_code.dictionary_hs_codes.code}
                          subtitle={hs_code.dictionary_hs_codes.description}
                          className={"badge"}
                        >
                        </ToolipsCustom>
                      </span>
                    );
                  })}
                {isEmpty(memberHsCode) &&
                  <div className="no-data">{<NoDataFound />}</div>
                }
              </div>


              {
                memberHsCode && size(memberHsCode) > 8 ? (
                  <ReadMore isReadMore={isHsReadMore} setIsReadMore={setHsReadMore} isExpanded={isHsExpanded} setIsExpanded={setHsExpanded} />
                ) : ""
              }
            </div>

            { /** Trading Countries */}
            <div className='card'>
              <h3>Trading Countries</h3>
              <div className='Hsn_badge'>
                {!isTargetReadMore && memberTargetCountries &&
                  memberTargetCountries.slice(0, 8).map(function (item, indx) {
                    return (
                      <span className="badge" key={`target-country-${indx}`}>
                        {item.country && item.country.name}
                      </span>
                    );
                  })}
                {isTargetReadMore && memberTargetCountries &&
                  memberTargetCountries.map(function (item, indx) {
                    return (
                      <span className="badge" key={`target-country-${indx}`}>
                        {item.country && item.country.name}
                      </span>
                    );
                  })}
                {isEmpty(memberTargetCountries) &&
                  <div className="no-data">{<NoDataFound />}</div>
                }
              </div>

              {
                memberTargetCountries && size(memberTargetCountries) > 8 ? (
                  <ReadMore isReadMore={isTargetReadMore} setIsReadMore={setTargetReadMore} isExpanded={isTargetExpanded} setIsExpanded={setTargetExpanded} />
                ) : ""
              }
            </div>

            { /** Ports */}
            {cInfo && cInfo.trade_mode_type === 'LOG_PTR' &&
              <div className='card'>
                <h3>Ports</h3>
                {!isEmpty(memberPort) &&
                  <div className="Hsn_badge">
                    {!isPortReadMore && memberPort && memberPort.slice(0, 8).map(function (ports, indx) {
                      const portName = capitalizeWords(ports.dictionary_ports.name);
                      return (
                        <span className="badge" key={`target-country-${indx}`}>
                          {portName}
                        </span>
                      );
                    })}
                    {isPortReadMore && memberPort && memberPort.map(function (ports, indx) {
                      const portName = capitalizeWords(ports.dictionary_ports.name);
                      return (
                        <span className="badge" key={`target-country-${indx}`}>
                          {portName}
                        </span>
                      );
                    })}

                  </div>
                }

                {
                  memberPort && size(memberPort) > 8 ? (
                    <ReadMore isReadMore={isPortReadMore} setIsReadMore={setPortReadMore} isExpanded={isPortExpanded} setIsExpanded={setPortExpanded} />
                  ) : ""
                }
                {isEmpty(memberPort) &&
                  <div className="no-data">{<NoDataFound />}</div>
                }

              </div>
            }

            {/* ******company Images & videos **** */}
            {showMediaSection &&
              <div className='card'>
                <h3 className=''>
                  {/* <img src={companyInoiconimg} alt="" className='company-info-icon-img-video' /> */}
                  Company Images/Videos
                </h3>
                {/* {showMediaSection && <div className='gallery-wrape'> */}
                <div className='gallery-wrape'>
                  <CompanyImageVideo
                    data={mediaDetails}
                    showLoading={props.showLoading}
                    hideLoading={props.hideLoading}
                  />
                </div>
                {/* } */}
              </div>
            }
          </div>
        </div>



        <h3 className='company-details-text not-veryfied' style={{ display: 'none' }}>
          {/* <img src={companyDetails} alt="" className='company-info-icon mx-1' /> */}
          <div>
            <img src={CompanyInfoIcon} alt="" className='company-info-icon mx-1' />
            Company Information
          </div>

          {/* {cInfo && (cInfo.status !== 1) && <div className='not-veryfied-logo'>
            <img src={NotVeryfiedots} alt="" />
            <img src={NotVeryfied} alt="" className='mx-2 not-veryfied-img' />
            <img src={NotVeryfiedots} alt="" />

          </div>} */}

          {/* {cInfo && (cInfo.status == 1) && (isEndUser || (user && user.email === "demo@orextrade.com")) &&
            <div class="d-flex justify-content-end">
              <div class="list-group">
                <Button className='btn-regi' type='button' onClick={() => handlePopupShow()}>
                  Post Your Business
                </Button>
              </div>
            </div>
          } */}
          <div className='d-flex'>
            {/* {cInfo && (cInfo.status !== 1) && <div className='not-veryfied-logo'>
              <img src={NotVeryfiedots} alt="" />
              <img src={NotVeryfied} alt="" className='mx-2 not-veryfied-img' />
              <img src={NotVeryfiedots} alt="" />
            </div>
            } */}
            {/*{(cInfo && (cInfo.data_source === 'WEB') && (cInfo?.trade_mode_type != 'BUYER') && (cInfo?.trade_mode_type === 'LOG_PTR')) && (user && user.member_id != id && user.trade_mode_type != 'LOG_PTR') && (isEndUser || (user && isDemoUser && user.trade_mode_type != 'LOG_PTR')) &&
              <Button className='btn-regi ms-3' type='button' onClick={() => handlePopupShow()}>
                Post Your Business
              </Button>

            }

            {(cInfo  && (cInfo.data_source === 'WEB') && (cInfo?.trade_mode_type != 'BUYER') && (cInfo?.trade_mode_type === 'SUPPLIER')) && (user && user.member_id != id && user.trade_mode_type != 'LOG_PTR') && (user && isDemoUser && user.trade_mode_type != 'LOG_PTR' || user.trade_mode_type === 'BUYER') &&
              <Button className='btn-regi ms-3' type='button' onClick={() => handlePopupShow()}>
                Post Your Business
              </Button>

              
            } */}

          </div>

        </h3>

      </div>


      {/* *********contect info &&& location**** */}

      <div className='contect-company' style={{ display: 'none' }}>
        <div className='contect-info-compnay-main company-pro-details bg-white'>
          <h3 className='d-flex justify-content-between align-items-center'>
            <div>
              <img src={companyDetails} alt="" className='company-info-icon mx-1' />
              Contact Information
            </div>
            {/* (isSuperAdmin || isDemoUser || (isEndUser && isDownloadable)) && chkList !== null && (
              <ButtonAdd
                className="py-0 d-flex align-items-center download-contact-btn"
                name={chkList == 0 ? 'downloadAll' : 'download'}
                onClick={handleDownloadChange}
              >
                <i className="fa-solid fa-upload"></i>
                {chkList == 0 ? 'Download All' : 'Download'}
                {chkList != 0 && <span className='count'>{size(chkList)}</span>}
              </ButtonAdd>
            ) */}

            {/* {chkList && chkList == 0 && 
              <ButtonAdd className={"py-0 d-flex align-items-center download-contact-btn"} name={'downloadAll'} onClick={handleDownloadChange}>
              <i class="fa-solid fa-upload"></i>
              Download All 
              </ButtonAdd>
            }

            {chkList && chkList != 0 &&
              <ButtonAdd className={"py-0 d-flex align-items-center download-contact-btn"} name={'download'} onClick={handleDownloadChange}>
              <i class="fa-solid fa-upload"></i>
              Download 
              <span className='count'>{size(chkList)}</span>
              </ButtonAdd>
            } */}


          </h3>

          {/* ****company-representive**** */}
        </div>

        {/* compnay-location */}

        <div className='contect-info-compnay-main company-pro-details bg-white' style={{ display: 'none' }}>
          <h3>
            <img src={companyLocation} alt="" className='company-info-icon mx-1' />
            Company Address
          </h3>

          <div className='row justify-content-center mx-3'>
            <div className='contect-info-child row justify-content-between mt-3 '>
              {/* head office===> */}



            </div>
          </div>

        </div>

      </div>
      {/* <ToastContainer /> */}

      {/** Post Inquiry Pop-up */}
      <MediumPopup
        title={`Post Your Inquiry to - ${cInfo && cInfo.company_name}`}
        mediummodalShow={mediummodalShow}
        setMediumModalShow={setMediumModalShow}
      // closeButtonLabel="Cancel"
      // okButtonLabel="Submit"
      // onSubmit={handleLogisticInquirySubmit} 
      >

        <div className='row my-3'>
          <div className="col-md-12 p-0">


            {
              cInfo && cInfo?.trade_mode_type === "LOG_PTR" && <LogisticInquiry mediummodalShow={mediummodalShow}
                setMediumModalShow={setMediumModalShow} pageView="pop_up" member_id={id} />
            }

            {
              cInfo && cInfo?.trade_mode_type !== "LOG_PTR" && <SupplierInquiry mediummodalShow={mediummodalShow}
                setMediumModalShow={setMediumModalShow} pageView="pop_up" member_id={id} fromPage="view" />
            }


          </div>
        </div>

      </MediumPopup>

      {/** Credit Exceed Popup */}
      <MediumPopup
        title={"No More Credits Today!"}
        mediummodalShow={creditModalShow}
        setMediumModalShow={setCreditModalShow}
        mdlType="sticky"
        titlePosition="center-align-title"
      >
        <CreditExceed isSticky={true} />
      </MediumPopup >

    </div>

  )

}

const mapStateToProps = (state) => {
  return {
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    viewCompany: (member_id) => dispatch(viewProfileAction(member_id)),
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),
    updateMemberCredit: (viewer_id, viewed_id) => dispatch(updateMemberCredit(viewer_id, viewed_id))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewProfile);
